import { Stats } from "fs";
import { StatsHistoryDTO } from "./stats.history.dto.model";

export class MessagingDTO {
  key:string;
}
